/**
 * @generated SignedSource<<3d7e5d20e0b6fe59f2b9427e40e88324>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FirstGroupRow_rankField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FirstGroupIssues">;
  readonly " $fragmentType": "FirstGroupRow_rankField";
};
export type FirstGroupRow_rankField$key = {
  readonly " $data"?: FirstGroupRow_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirstGroupRow_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FirstGroupRow_rankField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FirstGroupIssues"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "7036d2690ec547661beb6083ae77c4c9";

export default node;
